"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Icon.css");
var Icon = (function (_super) {
    __extends(Icon, _super);
    function Icon(props) {
        var _this = _super.call(this, props) || this;
        _this.generateClasses = _this.generateClasses.bind(_this);
        _this.constructClass = _this.constructClass.bind(_this);
        _this.customizeEnums = _this.customizeEnums.bind(_this);
        _this.findRotationDegreeClass = _this.findRotationDegreeClass.bind(_this);
        return _this;
    }
    Icon.prototype.generateClasses = function () {
        var _a = this.props, color = _a.color, iconName = _a.iconName, isWidthFixed = _a.isWidthFixed, size = _a.size;
        return [
            'p-icon',
            this.constructClass(iconName, 'p-icon'),
            this.constructClass(size, 'p-f-sz'),
            this.constructClass(color, 'p-t'),
            this.findRotationDegreeClass(),
            isWidthFixed && 'p-icon-fixed-width',
        ].filter(Boolean).join(' ');
    };
    Icon.prototype.findRotationDegreeClass = function () {
        var _a = this.props, shouldFlipForRtl = _a.shouldFlipForRtl, rotationDegree = _a.rotationDegree;
        var isRtlIconFlippable = document.documentElement.getAttribute('dir') === 'rtl' && shouldFlipForRtl;
        if (rotationDegree === '180' && isRtlIconFlippable) {
            return '';
        }
        if (rotationDegree) {
            // rotate based on rotationDegree prop
            return this.constructClass(rotationDegree, 'p-rotate');
        }
        if (!rotationDegree && isRtlIconFlippable) {
            return this.constructClass('180', 'p-rotate');
        }
        return '';
    };
    Icon.prototype.constructClass = function (prop, prefix) {
        if (prop && prop !== 'None') {
            var customProp = this.customizeEnums(prop);
            return prefix + "-" + customProp;
        }
        return '';
    };
    Icon.prototype.customizeEnums = function (en) {
        var cases = {
            'Xsmall': 'xs',
            'Small': 'sm',
            'Medium': 'md',
            'Large': 'lg',
            'Xlarge': 'xl',
            'Xlarge2': '2x',
            'Xlarge3': '3x',
            'Xlarge4': '4x',
            'Primary': 'Primary50',
            'Secondary': 'Secondary50',
            'Success': 'Success50',
            'Warning': 'Warning50',
            'Error': 'Error50',
            'Info': 'Info50',
        };
        return cases[en]
            ? cases[en].toLowerCase()
            : en.toLowerCase();
    };
    Icon.prototype.render = function () {
        var _a = this.props, tooltip = _a.tooltip, tag = _a.tag, ariaHidden = _a.ariaHidden, role = _a.role;
        var attrs = {};
        if (tag !== null) {
            attrs['data-tag'] = tag;
        }
        if (tooltip !== null) {
            attrs['title'] = tooltip;
        }
        return (React.createElement("i", __assign({}, __assign({ className: this.generateClasses() }, attrs, { 'aria-hidden': ariaHidden, role: role }))));
    };
    return Icon;
}(React.Component));
Icon.defaultProps = {
    ariaHidden: false,
    color: 'Default',
    isWidthFixed: false,
    shouldFlipForRtl: false,
    role: '',
    rotationDegree: '',
    size: 'Medium',
    tag: null,
    tooltip: null,
};
exports.default = Icon;
//# sourceMappingURL=Icon.js.map


//////////////////
// WEBPACK FOOTER
// ../player-icon/build/control/Icon.js
// module id = 958
// module chunks = 0